<template>
    <div class="bg_blue">
        <div class="container_wrap">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
                <el-breadcrumb-item :to="{ path: '/indexpc'}">首页</el-breadcrumb-item>
                <el-breadcrumb-item> 校局长论坛</el-breadcrumb-item>
            </el-breadcrumb> 

            <!-- <el-collapse v-model="activeNames"  >
                <el-collapse-item :title="group.name"  v-for="(group,index) in groupList" :key="index" :name="index">
                    <div>{{group.desc}}</div>
                    <div>
                        <div  v-for="(item,vindex) in group.list" :key="vindex" >
                            {{item.name}}
                            <el-button type="primary" @click="goApply(item)">立即报名</el-button>
                            <el-button  @click="showDetail(item)">章程</el-button>
                        </div>

                    </div>
                </el-collapse-item>
            </el-collapse> -->

            <el-collapse v-model="activeNames"  class="elcollapse">
                <el-collapse-item :title="group.name"  v-for="(group,index) in groupList" :key="index" :name="index">
                    <div class="elcollapse_group_desc">{{group.desc}}</div>
                    <div>
                        <div  v-for="(item,vindex) in group.list" :key="vindex" class="apply_and_name">
                            <p>{{item.name}}</p>
                            <div class="apply_but">
                                <el-button type="primary" @click="goApply(item)">立即报名</el-button>
                                <el-button  @click="showDetail(item)">章程</el-button>
                            </div>
                        </div>

                    </div>
                </el-collapse-item>
            </el-collapse>

            <el-dialog title="章程" :visible.sync="dialogVisible">
                <div v-html="detail.content" class="html-data">

                </div>

                <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">关闭</el-button>
          <el-button type="primary" @click="goApply(detail)"
          >立即报名</el-button
          >
        </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";
    import NewsListItem from "@/components/listItem/NewsListItem";
    import { CountDown } from "vant";

    Vue.use(CountDown);

    export default {
        name: "CmsDetail",
        data() {
            return {
                dialogVisible: false,
                activeName: "1",
                type:'',
                activeNames:[
                    0,1,2,3
                ],
                row: {
                    id: 0,
                    current_index: 0,
                    user: {},
                    kaoji: {},
                },
                groupList:[

                ],
                detail:{

                }
            };
        },
        components: {
            NewsListItem,
        },
        computed: {},
        mounted() {
            let that = this;
            that.fetch();
        },
        methods: {
            fetch(){
                let that = this;
                that.$api.post("/api/luntan/groupList", {
                }, (r) => {
                    that.groupList = r.data;
                });
            },
            goApply(item){
                this.$router.push({
                    name:'LuntanApplyStep1',
                    query:{
                        saiqu_id:item.id
                    }
                })
            },
            showDetail(row){
                this.dialogVisible = true;
                this.detail = row;
            }
        },
    };
</script>
<style scoped lang="scss">
/deep/.elcollapse{
  .el-collapse-item{
    .el-collapse-item__header{
      padding-left: 15px;
      .el-collapse-item__arrow{
        margin: 0 80px 0 auto;
      }
    }
    .el-collapse-item__wrap{
        padding-left: 15px;
        .apply_and_name{
            padding-bottom: 20px;
        }
    }
  }
  .elcollapse_group_desc{
      color: #666;
  }
  .apply_and_name{
      display: flex;
      flex-direction: row;
      align-items: center;
      p{
          flex: 2;
          font-size: 20px;
        font-weight: bold;
        white-space: nowrap;
        overflow: hidden; 
        text-overflow: ellipsis;
      }
      .apply_but{
          flex: 1;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content:center;
      }

  }
}
    .status-1 {
        background: #559f07;
        color: #fff;
    }
    .status-2 {
        background: #e02020;
        color: #fff;
    }
    .status-0 {
        background: #f4faff;
        color: #666666;
    }
    .bg_blue {
        width: 100%;
        background: #f4faff;
        height: 100%;
        overflow: hidden;
    }
    .container_wrap {
        width: 1240px;
        margin: 0 auto;
        min-height: 1235px;
    }
    .breadcrumb {
        margin-top: 21px;
        margin-left: 23px;
        margin: 21px 0 20px 23px;
    }
    .elalert {
        margin: 0 0 40px 0;
    }
    .left_and_right_container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .container_list_item {
            width: 610px;
            height: 460px;
            background: #fdfdfd;
            box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
            border-radius: 68px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .item_pic {
                width: 92px;
                height: 106px;
                background: url("~@/assets/images/listitem/编组 4@2x.png") no-repeat
                center center;
                background-size: 100% 100%;
            }
            .item_title {
                height: 25px;
                font-size: 18px;
                font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
                font-weight: 500;
                color: #333333;
                line-height: 25px;
                margin: 24px 0 0 0;
            }
            .item_but_up {
                margin: 40px 0 24px 0;

                /deep/.el-button {
                    font-size: 14px;
                    font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
                    font-weight: 500;
                    background: #d3ebff;
                    width: 229px;
                    height: 44px;
                    color: #333333;
                    border: none;
                    &:hover {
                        opacity: 0.9;
                        font-weight: bold;
                    }
                }
            }
            .item_but_down {
                /deep/.el-button {
                    font-size: 14px;
                    font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
                    font-weight: 500;
                    background: #0091ff;
                    width: 229px;
                    height: 44px;
                    border: none;
                    border-radius: 22px;
                    &:hover {
                        opacity: 0.9;
                        font-weight: bold;
                    }
                }
            }
            &:nth-child(2) {
                .item_pic {
                    background: url("~@/assets/images/listitem/形状@2x.png") no-repeat
                    center center;
                    background-size: 100% 100%;
                }
                .item_but_up {
                    margin: 40px 0 24px 0;
                    /deep/.el-button {
                        background: #ffc79f;
                    }
                }
                .item_but_down {
                    /deep/.el-button {
                        background: #fa6400;
                    }
                }
            }
        }

        // .container_left {
        //   width: 212px;
        //   height: 560px;
        //   background: #ffffff;
        //   box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
        //   border-radius: 32px;
        // }
        // .container_center {
        //   width: 716px;
        //   height: 560px;
        //   background: #ffffff;
        //   box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
        //   border-radius: 32px;
        // }

        // .container_right {
        //   width: 296px;
        //   height: 560px;
        //   background: #ffffff;
        //   box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
        //   border-radius: 32px;
        // }
    }
</style>


// WEBPACK FOOTER //
// LuntanApplyIndex.vue?7b20eb67